import React, { ReactElement } from 'react'
import { ProgramUsageChart } from 'src/ui/page/sm/program-usage/list/ProgramUsageChart'

export const UtilizationCompareMachineGroupsChart = (): ReactElement => {
  return <ProgramUsageChart isUtilizationChart />
}
